module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.groups.title":"Groups","settings.groups.subtitle":"Groups of users who can be invited to multiple tenants and inheret permissions granted to a group."}}')
  delete Component.options._Ctor
}
